import React from "react";

export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
      <div className="min-w-0">
        <h1 className="font-display text-3xl sm:text-4xl text-[#0B1038] tracking-tight leading-tight break-words">
          {title}
        </h1>
        {subtitle && (
          <p className="text-gray-600 mt-2 text-sm sm:text-base max-w-2xl">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}
